var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "23px",
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xiQ-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav_campaigns_hover",
    transform: "translate(-21.000000, -19.000000)",
    fill: "#27ce0a",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1666667,19 L43.9583333,19 C42.7734918,19.0028835 41.7659147,19.865296 41.5802125,21.0354979 L26.8776958,24.1859854 C26.5234876,23.2485979 25.6270743,22.6274364 24.625,22.625 L23.4166667,22.625 C22.0825169,22.6262989 21.0012989,23.7075169 21,25.0416667 L21,34.7083333 C21.0012989,36.0424831 22.0825169,37.1237011 23.4166667,37.125 L24.625,37.125 C25.4207432,37.1244044 26.1650854,36.7317235 26.6148229,36.0752604 L28.2553167,36.3682208 L28.2553167,39.5416667 C28.2553136,40.0810364 28.6127844,40.5550921 29.1313583,40.7034188 L33.3552083,41.9117521 C33.7198858,42.0136809 34.111211,41.9409 34.4148563,41.7146729 C34.7176733,41.4864036 34.8957636,41.1292163 34.8958333,40.75 L34.8958333,37.5539583 L41.5839583,38.748275 C41.7847642,39.9033118 42.7859741,40.7473852 43.9583333,40.75 L45.1666667,40.75 C46.5008164,40.7487011 47.5820344,39.6674831 47.5833333,38.3333333 L47.5833333,21.4166667 C47.5820344,20.0825169 46.5008164,19.0012989 45.1666667,19 Z M24.625,34.7083333 L23.4166667,34.7083333 L23.4166667,25.0416667 L24.625,25.0416667 L24.625,34.7083333 Z M27.0416667,26.6228917 L41.5416667,23.5157833 L41.5416667,36.2859938 L27.0416667,33.6967167 L27.0416667,26.6228917 Z M32.4791667,39.1475688 L30.6719833,38.6307042 L30.6719833,36.8000792 L32.4791667,37.1224625 L32.4791667,39.1475688 Z M45.1666667,38.3333333 L43.9583333,38.3333333 L43.9583333,21.4166667 L45.1666667,21.4166667 L45.1666667,38.3333333 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/Speaker.e002d8c3.svg";
export { ForwardRef as ReactComponent };